import { createTheme } from "@material-ui/core";

export const colors = {
    brand: {
        100: '#00B881',
        200: '#00A372',
        300: '#008F64',
        400: '#007A56',
        500: '#006647', 
        600: '#005239',
        700: '#003D2B',
        800: '#00291D',
        900: '#00140E'
    }
};

const theme = createTheme({
    palette: {
        primary: {
            main: colors.brand[500]
        }
    }, 
    typography: {
        h1: { fontFamily: "\"Roboto Consolidated\", \"Helvetica\", \"Arial\", sans-serif", textTransform: 'uppercase' }, 
        h2: { fontFamily: "\"Roboto Consolidated\", \"Helvetica\", \"Arial\", sans-serif", textTransform: 'uppercase' }, 
        h3: { fontFamily: "\"Roboto Consolidated\", \"Helvetica\", \"Arial\", sans-serif", textTransform: 'uppercase' }, 
        h4: { fontFamily: "\"Roboto Consolidated\", \"Helvetica\", \"Arial\", sans-serif", textTransform: 'uppercase' }, 
        h5: { fontFamily: "\"Roboto Consolidated\", \"Helvetica\", \"Arial\", sans-serif", textTransform: 'uppercase' }, 
        h6: { fontFamily: "\"Roboto Consolidated\", \"Helvetica\", \"Arial\", sans-serif", textTransform: 'uppercase' }
    }
});

export default theme;